import React from 'react';
import { useSelector } from 'react-redux';
import { GenericChartCard } from '../../../../component/charts/genericChartCard';
import { ErrorState } from './errorState';
import { generateTitleAndSource } from './socioeconomicDemographicCharts';
import nls from '../nls/pt-BR.json';
import { useSocioeconomicChartsData } from '../../../../hooks/useSocioeconomicChartsData';

export const AgeDistribution: React.FC = () => {
  const { errorFetchData } =
    useSelector((state: any) => state.socioeconomicDemographicState) || '';
  const { ageDistribution } = useSocioeconomicChartsData();
  return (
    <GenericChartCard
      title={generateTitleAndSource(
        nls.charts.ageDistribution.ageDistribution,
        nls.disclaimers.dataSourceIBGE2010
      )}
    >
      {errorFetchData?.ageDistribution ? (
        <ErrorState />
      ) : (
        <>
          <table>
            <tr>
              <th>{nls.charts.ageDistribution.ageGroup}</th>
              <th>{nls.charts.ageDistribution.population2021}</th>
            </tr>
            {Object.keys(ageDistribution || []).map((distribution, index) => {
              return (
                <tr key={index}>
                  <td>{distribution}</td>
                  <td>{ageDistribution[distribution]}</td>
                </tr>
              );
            })}
          </table>
        </>
      )}
    </GenericChartCard>
  );
};
